
export class StudentDiplomaCourse {
  courseName: string;
  credits: number;
  grade?: number;
}
